var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C8 0.895431 8.89543 0 10 0C11.1046 0 12 0.895431 12 2C12 2.06684 11.9967 2.13292 11.9903 2.19808C16.5596 3.12087 20 7.15866 20 12H0C0 7.15866 3.44038 3.12087 8.00969 2.19808C8.00328 2.13292 8 2.06684 8 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15H2.58579L3.29289 15.7071C3.48043 15.8946 3.73478 16 4 16H16C16.2652 16 16.5196 15.8946 16.7071 15.7071L17.4142 15H20V13H0V15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullboard);
export default __webpack_public_path__ + "static/media/fullboard.2cadae901e1e3918176fb2b86ebe3320.svg";
export { ForwardRef as ReactComponent };